import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=73010c80&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=73010c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73010c80",
  null
  
)

export default component.exports